import { c as _c } from "react/compiler-runtime";
import { AnimatePresence, motion } from 'framer-motion';
import type { ReactNode } from 'react';
import { useEffect, useState } from 'react';
import { TRANSITION_DELAY_DEFAULT } from '../../constants';
const successFeedbackVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      delay: 0.3,
      duration: 0.35
    }
  },
  exit: {
    opacity: 0,
    y: -20,
    transition: {
      duration: 0.35
    }
  }
};
const nextSideVariants = {
  hiddenBelow: {
    opacity: 0,
    y: 20
  },
  slideIn: {
    opacity: 1,
    y: 0,
    transition: {
      delay: 0.1,
      duration: 0.35
    }
  },
  exit: {
    opacity: 0
  }
};
type IdDocAnimationProps = {
  mode: 'loading' | 'success';
  hasNextSide: boolean;
  loadingComponent: ReactNode;
  successComponent: ReactNode;
  nextSideComponent?: ReactNode;
};
const IdDocAnimation = t0 => {
  const $ = _c(23);
  const {
    mode,
    hasNextSide,
    loadingComponent,
    successComponent,
    nextSideComponent
  } = t0;
  const [isShowingSuccess, setIsShowingSuccess] = useState(false);
  const [isShowingNextSide, setIsShowingNextSide] = useState(false);
  let t1;
  let t2;
  if ($[0] !== hasNextSide || $[1] !== mode) {
    t1 = () => {
      if (mode === "success") {
        setIsShowingSuccess(true);
        setTimeout(() => {
          if (hasNextSide) {
            setIsShowingSuccess(false);
            setIsShowingNextSide(true);
          }
        }, TRANSITION_DELAY_DEFAULT);
      }
    };
    t2 = [mode, hasNextSide];
    $[0] = hasNextSide;
    $[1] = mode;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] !== loadingComponent || $[5] !== mode) {
    t3 = mode === "loading" && <motion.div exit={{
      opacity: 0
    }}>{loadingComponent}</motion.div>;
    $[4] = loadingComponent;
    $[5] = mode;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <AnimatePresence>{t3}</AnimatePresence>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== isShowingSuccess || $[10] !== successComponent) {
    t5 = isShowingSuccess && <motion.div className="absolute left-0 right-0" initial="hidden" animate="visible" exit="exit" variants={successFeedbackVariants}>{successComponent}</motion.div>;
    $[9] = isShowingSuccess;
    $[10] = successComponent;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t5) {
    t6 = <AnimatePresence>{t5}</AnimatePresence>;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== isShowingNextSide || $[15] !== nextSideComponent) {
    t7 = isShowingNextSide && <motion.div className="absolute left-0 right-0" initial="hiddenBelow" animate="slideIn" exit="exit" variants={nextSideVariants}>{nextSideComponent}</motion.div>;
    $[14] = isShowingNextSide;
    $[15] = nextSideComponent;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t7) {
    t8 = <AnimatePresence>{t7}</AnimatePresence>;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t4 || $[20] !== t6 || $[21] !== t8) {
    t9 = <>{t4}{t6}{t8}</>;
    $[19] = t4;
    $[20] = t6;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  return t9;
};
export default IdDocAnimation;